// <%= vite_javascript_tag 'stimulus' %>
import { Application } from "@hotwired/stimulus";

const application = Application.start();
window.Stimulus = application;

// Autoload all controllers from ./controllers/**/*_controller.js
// @ts-expect-error -- this meta.glob takes options, TS is wrongly complaining
const controllerModules = import.meta.glob("../src/controllers/**/*_controller.{js,ts}", {
  eager: true,
});

for (const path in controllerModules) {
  const module = controllerModules[path];
  // @ts-expect-error -- TS can't infer the type here
  const controller = module.default;
  if (!controller) continue;

  // Derive identifier from file path:
  // "./controllers/admin/user_menu_controller.js" -> "admin--user-menu"
  const match = path.match(/controllers\/(.+)_controller\.([jt])s$/);
  if (!match) continue;

  const identifier = match[1].replace(/\//g, "--").replace(/_/g, "-");

  application.register(identifier, controller);
}

export { application };
